import * as React from "react";

import PropTypes from "prop-types";
import { Modal, Button, Icon } from "semantic-ui-react";
import InputComponent from "../../InputComponent";
import styles from "./DeleteSubscriptionModal.module.css";
import { FaFileUpload } from "react-icons/fa";
import spinner from "../../../static/images/preloader.png";

const { useState } = React;

function DeleteSubscriptionModal({
  visibility,
  onOpenModal,
  onCloseModal,
  onConfirm,
  loading = false,
}) {
  return (
    <Modal
      size="small"
      centered
      open={visibility}
      onOpen={onOpenModal}
      onClose={onCloseModal}
    >
      <div className={`${styles.modalContainer} flex flex-col`}>
        {loading ? (
          <div className={`flex flex-col justify-center items-center`}>
            <img src={spinner} className={`block`} />

            <div>Deleting subscription...</div>
          </div>
        ) : (
          <>
            <Button
              className={styles.closeButton}
              onClick={onCloseModal}
              size="big"
              icon="close"
            />
            <text className={`${styles.headerText} block mb-4`}>
              Are you sure you want to delete subscription?
            </text>
            <text className={`${styles.subText} block mb-8`}>
              Deleted subscriptions will be held in “Deleted” tab until you
              restore or delete them permanently.
            </text>

            <div
              className={`${styles.btnRow} flex items-center justify-center`}
            >
              <button
                onClick={onConfirm}
                className={`${styles.btnGreen} mr-2.5`}
              >
                Delete subscription
              </button>
              <button onClick={onCloseModal} className={`${styles.btnRed}`}>
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

DeleteSubscriptionModal.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default DeleteSubscriptionModal;
